import * as Sentry from '@sentry/react';
import { Routes } from 'react-router-dom';

import { shouldInitSentry } from 'services/log/utils';

const RoutesWrapper = shouldInitSentry ? Sentry.withSentryReactRouterV6Routing(Routes) : Routes;

export default RoutesWrapper;
